import { useMsal } from '@azure/msal-react';
import { UserWidgetProps } from '@versita/frontend/campus-ui-web';
import { environment } from '@versita/frontend/auth-web';
import {
  useGetUserPhotoQuery,
  useGetUserPhotoDetailsQuery,
} from '../services/msGraph';

/**
 * Provides the appropriate functions and data to render the user widget that is
 * used in <PageHeader />
 */
export const useUserWidget = (): UserWidgetProps => {
  const { instance } = useMsal();
  const account = instance?.getActiveAccount();
  const { data: userPhotoDetails } = useGetUserPhotoDetailsQuery(
    {},
    { skip: !account },
  );
  const { data: userPhoto } = useGetUserPhotoQuery(
    {},
    { skip: !account || !userPhotoDetails?.height },
  );
  const userName = account?.idTokenClaims?.name;
  const login = () => {
    instance.acquireTokenRedirect({
      scopes: environment.loginScopes,
    });
  };
  const logout = () => {
    instance.logoutRedirect({
      account,
      postLogoutRedirectUri: '/',
    });
  };
  return {
    login,
    logout,
    userName,
    userPhoto,
  };
};
